import { PlotDetailPage } from '@/components/plots/plot-detail-page'

export function AdminPlotDetail() {
  return <PlotDetailPage plotsBasePath="/admin/plots" membersBasePath="/admin/members" canManage />
}
